import type { ExperimentConfig } from '../@types'

const config: ExperimentConfig[] = [
	{
		'activity-female-tai-chi-walking-v2': {
			// /result_complete?safe&mock-data&utm_source=FB&country=US&area=activity-female-tai-chi-walking-v2&exp=web_upsell_price_based_card_type~1
			upsell: {
				experiment: {
					'upsell-tai-chi-walking-f-move': () =>
						import('@/modules/Upsell/instances/experiments/web_upsell_price_based_card_type'),
				},
			},
		},
		'activity-female-walking': {
			// /result_complete?safe&mock-data&utm_source=FB&country=US&area=activity-female-walking&exp=web_upsell_price_based_card_type~1
			upsell: {
				experiment: {
					'upsell-activity-f': () => import('@/modules/Upsell/instances/experiments/web_upsell_price_based_card_type'),
				},
			},
		},
		'activity-male-walking': {
			// /result_complete?safe&mock-data&utm_source=FB&country=US&area=activity-male-walking&exp=web_upsell_price_based_card_type~1
			upsell: {
				experiment: {
					'upsell-activity-m': () => import('@/modules/Upsell/instances/experiments/web_upsell_price_based_card_type'),
				},
			},
		},
	},
]

export default config
